import {ValueObject} from '@s-ui/domain'

export class PriceRangeMetaDataSearchValueObject extends ValueObject {
  #highPrice
  #lowPrice
  #offerCount

  constructor({highPrice, lowPrice, offerCount}) {
    super()
    this.#highPrice = highPrice
    this.#lowPrice = lowPrice
    this.#offerCount = offerCount
  }

  static create({priceRange}) {
    return new PriceRangeMetaDataSearchValueObject({
      highPrice: priceRange.highPrice,
      lowPrice: priceRange.lowPrice,
      offerCount: priceRange.offerCount
    })
  }

  get highPrice() {
    return this.#highPrice
  }

  get lowPrice() {
    return this.#lowPrice
  }

  get offerCount() {
    return this.#offerCount
  }

  get value() {
    return {highPrice: this.#highPrice, lowPrice: this.#lowPrice, offerCount: this.#offerCount}
  }

  toJSON() {
    return {highPrice: this.#highPrice, lowPrice: this.#lowPrice, offerCount: this.#offerCount}
  }
}
